import { secondAxios } from "../../../../../../../api/axios";

export const getPlantPos = async (plantId) => {
  const response = await secondAxios.get(`/po?plantId=${plantId}`);
  console.log({ plantId, response });
  return response.data;
};

export const getPoMaterials = async (poId) => {
  const response = await secondAxios.get(`/po/${poId}`);
  // console.log(response);
  return response.data;
};

export async function getAllPlantPos(plantId, setPos) {
  const pos = await getPlantPos(plantId);

  setPos(pos);
}

export const getPoPayments = async (poId) => {
  const response = await secondAxios.get(`/payment`, {
    params: { poId },
  });
  return response.data;
};

export const createPayment = async (paymentData) => {
  const response = await secondAxios.post(`/payment`, paymentData);
  return response.data;
};

export const updatePayment = async (id, paymentData) => {
  const response = await secondAxios.patch(`/payment/${id}`, paymentData);
  return response.data;
};

export const deletePayment = async (id) => {
  const response = await secondAxios.delete(`/payment/${id}`);
  return response.data;
};
